import React, { useState } from 'react';
import { Grid, TextField, Button, Typography } from '@material-ui/core';
import emailjs from 'emailjs-com';

import './Contact.css';

const SUCCESS_MESSAGE = 'El mensaje ha sido enviado correctamente, pronto nos comunicaremos contigo.'
const ERROR_MESSAGE = 'El mensaje no ha podido enviarse. Por favor intentalo nuevamente mas tarde.'

const Contact = ({ reference }) => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)
  const [showErrorMessage, setShowErrorMessage] = useState(false)
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    telephone: '',
    message: '',
  });

  const onFormChange = (property) => ({ target: { value } }) => {
    const newFormData = {
      ...formData,
      [property]: value,
    };
    setFormData(newFormData);
  };

  const sendForm = (event) => {
    event.preventDefault();

    emailjs.send('service_82cb0hb', 'template_t5jvfoq', formData, 'user_vyVNx0cDiySOX9bSy4409')
      .then(() => {
        setShowSuccessMessage(true)
        setShowErrorMessage(false)

        setTimeout(() => {
          setShowSuccessMessage(false)
          setFormData({
            fullName: '',
            email: '',
            telephone: '',
            message: '',
          })
        }, 6000)
      }, () => {
        setShowSuccessMessage(false)
        setShowErrorMessage(true)
        setTimeout(() => setShowErrorMessage(false), 8000)
      });
  };

  const openWhatsapp = () => {
    const url = 'https://wa.me/5493541226905'

    let text = `Mensaje desde www.ernestinavillage.com.ar:\r\n${formData.message}\r\n`
    text += `\r\nNombre: ${formData.fullName}\r\n`
    text += `Mail: ${formData.email}\r\n`
    text += `Teléfono: ${formData.telephone}`

    window.open(`${url}?text=${encodeURI(text)}`)
  }

  return (
    <div className="Contact Contact__Container" ref={reference} id="pepe">
      <div className="Contact__Title">
        <Typography variant="h5" color="primary">
          Contactate con nosotros!
        </Typography>
      </div>

      <div className="Contact__Content">
        <Grid container spacing={3}>
          <Grid item lg={5} md={5} sm={12} xs={12}>
            <div className="Contact__Content__Map">
              <iframe title="Ernestina Village Map" width="100%" height="400" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1218.3157108315386!2d-64.51285454942946!3d-31.389658353457385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x942d65e58293a20f%3A0xe2aeff72110095a4!2sErnestina%20Village!5e0!3m2!1ses-419!2sar!4v1611066979363!5m2!1ses-419!2sar" frameBorder="0" allowFullScreen="" aria-hidden="false"></iframe>
            </div>
          </Grid>
          <Grid item container lg={7} md={7} sm={12} alignItems="center">
            <form onSubmit={sendForm}>
              <TextField
                required
                label="Nombre y Apellido"
                value={formData.fullName}
                onChange={onFormChange("fullName")}
                fullWidth
                className="Contact__Form--textField"
                variant="outlined"
              />
              <TextField
                required
                label="Correo"
                value={formData.email}
                onChange={onFormChange("email")}
                fullWidth
                className="Contact__Form--textField"
                variant="outlined"
              />
              <TextField
                required
                label="Teléfono/celular"
                value={formData.telephone}
                onChange={onFormChange("telephone")}
                fullWidth
                className="Contact__Form--textField"
                variant="outlined"
              />
              <TextField
                required
                label="Mensaje"
                value={formData.message}
                onChange={onFormChange("message")}
                fullWidth
                multiline
                rows={6}
                className="Contact__Form--textField"
                variant="outlined"
              />

              {showSuccessMessage &&
                <div className="Contact__Form__Response Contact__Form__Response--success">
                  {SUCCESS_MESSAGE}
                </div>
              }

              {showErrorMessage &&
                <div className="Contact__Form__Response Contact__Form__Response--error">
                  {ERROR_MESSAGE}
                </div>
              }

              <Grid container spacing={3} wrap='nowrap'>
                <Grid item container lg={7} md={7} sm={12} alignItems="center">
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    fullWidth
                    className="Contact__Form--button"
                  >
                    Enviar Mail
                  </Button>
                </Grid>

                <Grid item container lg={7} md={7} sm={12} alignItems="center">
                  <Button
                    type="button"
                    color="primary"
                    variant="contained"
                    fullWidth
                    className="Contact__Form--button-green"
                    onClick={openWhatsapp}
                  >
                    Contactar por WhatsApp
                  </Button>

                </Grid>
              </Grid>
            </form>

          </Grid>
        </Grid>
      </div>
    </div>

  );
};

export default Contact;
